import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/api/auth';
import config from 'BRAND/config';
import authorityGuard from './AuthorityGuard';

const routerInstance = {
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: '*',
      name: 'Root'
    },
    ...config.routes
  ]
};

Vue.use(Router);
const router = new Router(routerInstance);
router.beforeEach((to, from, next) => {
  if (to.fullPath.startsWith('/#')) {
    next(to.fullPath.replace('/#', ''));
  } else {
    next();
  }
});

router.beforeEach(auth.samlGuard);
router.beforeEach(auth.loginGuard);
router.beforeEach(auth.rootGuard);
router.beforeEach(authorityGuard.authorityGuard);
router.afterEach((to, from) => {
  if (process.env.NODE_ENV === 'production') {
    // Dirty solution to get Vue context
    const ga = new Vue().$ga;
    if (ga) ga.page(to.fullPath);
  }
  const url = window.location.search;

  const urlParams = new URLSearchParams(url);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const oauthToken = urlParams.get('oauth_token');
  const oauthVerifier = urlParams.get('oauth_verifier');
  let scope = urlParams.get('scope');
  const error = urlParams.get('error');

  if (error != null) {
    window.history.pushState({}, document.title, window.location.pathname);
    this.$router.replace({name: 'integration'});
  }

  let comesFromFitbit = code != null && state != null && state.toString() === '2';
  let comesFromGoogleOAuth = state != null && state.toString() === '3' && code != null;
  let comesFromGarmin = oauthToken != null && oauthVerifier != null;

  if (comesFromGoogleOAuth) {
    const scope = urlParams.get('scope');
    router.replace({name: 'integration', query: {code: code, state: '3', scope: scope}});
  } else if (comesFromFitbit) {
    router.replace({name: 'integration', query: {code: code, state: '2'}});
  } else if (comesFromGarmin) {
    let status = '4';
    router.replace({
      name: 'integration',
      query: {oauthToken: oauthToken, state: status, oauthVerifier: oauthVerifier}
    });
  } else if (state != null) {
    router.replace({name: 'integration', query: {code: code, state: state, scope: scope}});
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js